import React, { useState } from "react";
import Sep from "./SeP";
import Loader from "./Loader";

export default function Secure() {
  const [show, setshow] = useState(false);
  const [finalPassword, setFianlPassword] = useState("");
  const [loader, setLoader] = useState(false);

  function requestHandler(e) {
    const formcontent = document.getElementById("in");

    e.preventDefault();
    if (formcontent.value === "") {
      alert("fill the form");
      formcontent.focus();
      return;
    } else if (formcontent.value.length < 4) {
      alert("password must contain 4 character");
      formcontent.value = "";
      formcontent.focus();
      return;
    }
    setLoader(true);

    const params1 = {
      method: "post",
      headers: {
        "content-type": "application/x-www-form-urlencoded",
      },
      body: `weak=${formcontent.value.toLowerCase()}`,
    };

    fetch("https://node-secure-app.herokuapp.com/", params1)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log(data);
        setFianlPassword(data);
        setLoader(true);

        setshow(true);
      })
      .catch((e) => {
        setLoader(false);
        setTimeout(() => {
          alert("An error occurred please try again");
        }, 500);
      });
  }
  return (
    <>
      {show ? (
        <Sep finalPassword={finalPassword} />
      ) : (
        <center>
          <div className="secure_container">
            <div className="secure_heading">
              <p className="secure_heading_info">
                please enter your weak password . will will make it more better
                and strong
              </p>
            </div>
            <div className="secure_input">
              <input
                type="text"
                placeholder="Enter your weak password"
                id="in"
                name="text"
              />
              <br />
              {loader ? (
                <Loader />
              ) : (
                <button type="submit" onClick={requestHandler}>
                  create
                </button>
              )}
            </div>

            <p className="small">
              We never save your password . Feel free to use our app
            </p>
            <br />
          </div>
        </center>
      )}
    </>
  );
}
